export default __webpack_public_path__ + "static/media/flippers-share.138fa6c9.png";